import { Theme, Font } from '@oneamerica/dxp-ui-components';
import ColorConstants from '../../../../../constants/ColorConstants';

export default () =>
  Theme.Responsive.create({
    placeholderWrapper: {
      minHeight: 24,
      justifyContent: 'center',
    },
    smModalTitle: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      fontFamily: Font.medium.fontFamily,
      fontSize: 16,
      fontWeight: '500',
      zIndex: -1,
      padding: 2,
      marginRight: 20 + 18,
    },
    mdModalTitle: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      fontFamily: Font.medium.fontFamily,
      fontSize: 16,
      fontWeight: '500',
      zIndex: -1,
      padding: 2,
      marginRight: 20 + 18,
    },
    lgModalTitle: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      fontFamily: Font.medium.fontFamily,
      fontSize: 18,
      fontWeight: '500',
      zIndex: -1,
      padding: 2,
      marginRight: 20 + 18,
    },
    smModalSubTitle: {
      fontSize: 10,
    },
    mdModalSubTitle: {
      fontSize: 11,
    },
    lgModalSubTitle: {
      fontSize: 12,
    },
    smModalSize: {
      margin: 'auto',
      maxHeight: '95%',
      width: '95%',
      flexGrow: 0,
      flexShrink: 0,
      flexBasis: 'auto',
    },
    mdModalSize: {
      margin: 'auto',
      width: 554,
      maxHeight: 662,
    },
    lgModalSize: {
      marginVertical: 'auto',
      marginHorizontal: 'auto',
      maxHeight: '90%',
      minWidth: '41.66%',
      maxWidth: '50%',
    },
    smCheckboxWrapper: { flex: 1 },
    mdCheckboxWrapper: { flex: 1 },
    lgCheckboxWrapper: { flex: 1 },
    smCheckboxText: { fontSize: 14 },
    mdCheckboxText: { fontSize: 18 },
    lgCheckboxText: { fontSize: 18 },
    smCurrencyWrapper: { fontSize: 14, textAlign: 'right' },
    mdCurrencyWrapper: { fontSize: 18, flex: 1 },
    lgCurrencyWrapper: { fontSize: 18, flex: 1 },
    centerAlign: { textAlign: 'center' },
    placeholderText: {
      fontFamily: Font.regular.fontFamily,
      fontSize: 14,
      color: ColorConstants.iron,
    },
    needToMakeChange: {
      color: ColorConstants.iron,
    },
    serviceRequestBtn: {
      fontSize: 15,
      fontFamily: Font.medium.fontFamily,
    },
    customeServiceRequestBtn: {
      backgroundColor: Theme.Color.ice4,
      borderRadius: 24,
      paddingHorizontal: 16,
      paddingVertical: 12,
    },
    tableRow: {
      backgroundColor: Theme.Color.table.row.background,
      flex: 1,
      flexDirection: 'row',
    },
    evenRow: { backgroundColor: Theme.Color.table.row.background },
    oddRow: {
      backgroundColor: Theme.Color.table.row.oddBackground,
    },
    tableCell: {
      paddingVertical: Theme.Metrics.xxSmall,
      paddingHorizontal: Theme.Metrics.xSmall,
    },
    tableCellLeft: {
      flex: 1,
      borderColor: Theme.Color.table.cell.borderColor,
      borderRightWidth: 1,
    },
    tableCellRight: {
      flex: 2,
    },
    tableCellLeftText: {
      color: ColorConstants.iron,
      fontFamily: Font.regular.fontFamily,
    },
    tableCellRightText: {
      fontFamily: Font.medium.fontFamily,
      color: ColorConstants.iron,
    },
    horizontalDivider: {
      backgroundColor: ColorConstants.grey200,
      height: 1,
      width: '100%',
    },
    headerCheckboxContainerStyle: {
      backgroundColor: ColorConstants.lightGrayishBlue,
      borderColor: ColorConstants.lightGrayishBlue,
      padding: 10,
      marginTop: 16,
      borderBottomWidth: 1,
      borderBottomColor: ColorConstants.grey200,
      borderStyle: 'solid',
    },
    smHeaderCheckboxTextStyle: {
      color: ColorConstants.oaBlue,
      fontSize: 16,
    },
    mdHeaderCheckboxTextStyle: {
      color: ColorConstants.oaBlue,
      fontSize: 20,
    },
    lgHeaderCheckboxTextStyle: {
      color: ColorConstants.oaBlue,
      fontSize: 22,
    },
    loanPaymentDisabledMessage: {
      fontFamily: Font.medium.fontFamily,
      fontSize: 12,
      color: ColorConstants.darkRed,
      paddingTop: 8,
      paddingRight: 10,
      paddingBottom: 10,
      paddingLeft: 10,
      borderBottomWidth: 1,
      borderBottomColor: ColorConstants.grey200,
      borderStyle: 'solid',
    },
    loanPaymentRow: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingTop: 12,
      paddingRight: 10,
      paddingBottom: 12,
      paddingLeft: 40,
      borderBottomWidth: 1,
      borderBottomColor: ColorConstants.grey200,
      borderStyle: 'solid',
    },
    loanPayoffRowNoBorder: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingTop: 12,
      paddingRight: 10,
      paddingBottom: 12,
      paddingLeft: 40,
    },
    loanInterestRowNoBorder: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingTop: 12,
      paddingRight: 10,
      paddingBottom: 12,
      paddingLeft: 40,
    },
    textInputContainer: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
    },
    textInputWrapper: {
      flex: 1,
      flexDirection: 'column',
    },
    dollarSign: {
      fontSize: 18,
      fontFamily: Font.regular.fontFamily,
      color: ColorConstants.iron,
      marginRight: 4,
    },
    textInput: {
      flex: 1,
      height: 48,
      borderWidth: 1,
      borderColor: ColorConstants.grey200,
      borderRadius: 4,
      paddingHorizontal: 12,
      paddingVertical: 10,
      fontFamily: Font.regular.fontFamily,
      fontSize: 15,
      color: ColorConstants.iron,
      outlineStyle: 'none',
      outlineWidth: 0,
    },
    textInputDisabled: {
      backgroundColor: '#EBEBEB',
    },
    textInputError: {
      borderColor: ColorConstants.darkRed,
    },
    errorText: {
      fontFamily: Font.regular.fontFamily,
      fontSize: 12,
      color: ColorConstants.darkRed,
      marginTop: 4,
      marginLeft: 14,
    },
    noteText: {
      fontFamily: Font.regular.fontFamily,
      fontSize: 12,
      color: ColorConstants.black,
      marginTop: 4,
      paddingLeft: 40,
      paddingBottom: 12,
      borderBottomWidth: 1,
      borderBottomColor: ColorConstants.grey200,
      borderStyle: 'solid',
    },
    disabledCurrencyText: {
      color: ColorConstants.placeholderText,
    },
    loanPayoffConflictMessage: {
      fontFamily: Font.regular.fontFamily,
      fontSize: 12,
      color: ColorConstants.darkRed,
      flex: 1,
      paddingRight: 12,
    },
     phnlinkStyle: {
          color: ColorConstants.oaBlueTint,
          fontSize: 12,
          fontFamily: Font.medium.fontFamily,
          //@ts-ignore
          display: 'inline-flex',
        },
    paymentCutoffMessage: {
      fontFamily: Font.regular.fontFamily,
      fontSize: 12,
      color: ColorConstants.iron,
      paddingRight: 12,
    },
  })();
